import React, { useEffect, useState } from "react";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PriceField from "Components/UI/Form/PriceField";
import {
  Checkbox,
  Collapse,
  Divider,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const DeliveryOptions = [
  { Value: 0, Name: "Ej vald" },
  { Value: 1, Name: "E-post" },
  { Value: 2, Name: "Print" },
  { Value: 4, Name: "E-faktura" },
];

export default function AgreementLevel({
  client,
  FORM_MODE,
  services,
  handleInputChange,
  boolOptions,
}) {
  const [showExtendedCredits, setShowExtendedCredits] = useState(false);
  useEffect(() => {
    if (client.DefaultService === "purchase") {
      if (client.AllowPurchase !== 1) {
        handleInputChange("AllowPurchase", 1);
      }

      if (client.Regress !== "1") {
        handleInputChange("Regress", "1");
      }
    }
  }, [client.DefaultService]);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        container
        xs={12}
        sm={6}
        md={
          client.DefaultService === "purchase" || client.AllowPurchase === 1
            ? 12
            : 4
        }
        direction="row"
        gap="10px"
      >
        <Grid item flex={1}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="DefaultService"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={client?.DefaultService}
              onChange={(e) =>
                handleInputChange("DefaultService", e.target.value)
              }
              label="Förvald tjänst"
            >
              {services?.map((paymentmethod) => (
                <MenuItem key={paymentmethod.Value} value={paymentmethod.Value}>
                  {paymentmethod.Name}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox
                disabled={
                  FORM_MODE === "LOCKED" ||
                  client?.DefaultService === "purchase"
                }
                checked={client.AllowPurchase === 1}
                onChange={(event) =>
                  handleInputChange(
                    "AllowPurchase",
                    event.target.checked ? 1 : 0
                  )
                }
              />
            }
            label="Tillåt köp"
          />
        </Grid>
        {client.DefaultService === "purchase" || client.AllowPurchase === 1 ? (
          <>
            <Grid item sm={6} md={4}>
              <PriceField
                name="MaxCredit"
                disabled={FORM_MODE === "LOCKED" ? true : false}
                label="Finansierad Limit"
                value={client.MaxCredit}
                size="small"
                color="primary"
                fullWidth
                margin="dense"
                type="number"
                onChange={(newVal) => handleInputChange("MaxCredit", newVal)}
              />
            </Grid>
            <Grid item sm={6} md={4}>
              <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
                <InputLabel>Regress utförs</InputLabel>
                <Select
                  name="Regress"
                  disabled={FORM_MODE === "LOCKED" ? true : false}
                  value={client.Regress}
                  onChange={(e) => handleInputChange("Regress", e.target.value)}
                  label="Regress utförs"
                  size="small"
                >
                  {boolOptions?.map((option) => (
                    <MenuItem
                      key={option.OptionId + "_" + option.Name}
                      value={option.Value}
                    >
                      {option.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        ) : null}
      </Grid>
      {client?.DefaultService === "purchase" || client?.AllowPurchase === 1 ? (
        <Grid item container spacing={2}>
          <Grid container item xs={12} sm={6} md={6} gap={1}>
            <TextField
              name="PurchaseCreditFeePercentage"
              disabled
              label="Kreditavgift på finansierat belopp %"
              value={`${client.Ffd1CreditFee}% (${client.FfdLevel1}dgr)`}
              type="text"
              size="small"
              margin="dense"
              sx={{ flex: 1 }}
            />
            <IconButton
              onClick={() => setShowExtendedCredits(!showExtendedCredits)}
            >
              {showExtendedCredits ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )}
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="PurchaseDirectPaymentPercentage"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Andel finansierat %"
              value={client.PurchaseDirectPaymentPercentage}
              onChange={(e) =>
                handleInputChange(
                  "PurchaseDirectPaymentPercentage",
                  e.target.value
                )
              }
              type="number"
              size="small"
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      ) : null}
      {client?.DefaultService === "purchase" || client?.AllowPurchase === 1 ? (
        <Grid container item>
          <Collapse in={showExtendedCredits} sx={{ width: "100%" }}>
            <Grid container md={6} sm={12}>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="FFD1"
                    label="FFD nivå 1"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.FfdLevel1}
                    onChange={(e) =>
                      handleInputChange("FfdLevel1", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="Ffd1CreditFee"
                    label="Avgift nivå 1"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.Ffd1CreditFee}
                    onChange={(e) =>
                      handleInputChange("Ffd1CreditFee", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="FfdLevel2"
                    label="FFD nivå 2"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.FfdLevel2}
                    onChange={(e) =>
                      handleInputChange("FfdLevel2", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="Ffd2CreditFee"
                    label="Avgift nivå 2"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.Ffd2CreditFee}
                    onChange={(e) =>
                      handleInputChange("Ffd2CreditFee", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="FfdLevel3"
                    label="FFD nivå 3"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.FfdLevel3}
                    onChange={(e) =>
                      handleInputChange("FfdLevel3", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>

                <Grid item sm={12} md={6}>
                  <TextField
                    name="Ffd3CreditFee"
                    label="Avgift nivå 3"
                    disabled={FORM_MODE === "LOCKED" ? true : false}
                    value={client.Ffd3CreditFee}
                    onChange={(e) =>
                      handleInputChange("Ffd3CreditFee", e.target.value)
                    }
                    size="small"
                    fullWidth
                    margin="dense"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      ) : null}
      <Grid item container spacing={2}>
        <Grid item container spacing={2}>
          <Grid item sm={12} md={12}>
            <Typography>Administrationsavgifter</Typography>
            <Divider />
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceField
              name="ServiceFeeCredit"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Kreditnota SEK"
              value={client?.ServiceFeeCredit}
              type="number"
              size="small"
              fullWidth
              margin="dense"
              onChange={(newVal) =>
                handleInputChange("ServiceFeeCredit", newVal)
              }
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceField
              name="ServiceFeeService"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Service SEK"
              value={client?.ServiceFeeService}
              type="number"
              size="small"
              fullWidth
              margin="dense"
              onChange={(newVal) =>
                handleInputChange("ServiceFeeService", newVal)
              }
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2} md={6}>
          <Grid item sm={12} md={6}>
            <PriceField
              name="Reminder1"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Påm1 SEK"
              value={client?.ServiceFeeReminder1}
              type="number"
              size="small"
              fullWidth
              margin="dense"
              onChange={(newVal) =>
                handleInputChange("ServiceFeeReminder1", newVal)
              }
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <PriceField
              name="Reminder2"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Påm2 SEK"
              value={client?.ServiceFeeReminder2}
              type="number"
              size="small"
              fullWidth
              margin="dense"
              onChange={(newVal) =>
                handleInputChange("ServiceFeeReminder2", newVal)
              }
            />
          </Grid>
        </Grid>
        {client?.DefaultService === "purchase" ||
        client?.AllowPurchase === 1 ? (
          <Grid item sm={12} md={6}>
            <PriceField
              name="ServiceFeePurchase"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              label="Köp SEK"
              value={client?.ServiceFeePurchase}
              type="number"
              size="small"
              fullWidth
              margin="dense"
              onChange={(newVal) =>
                handleInputChange("ServiceFeePurchase", newVal)
              }
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid item container spacing={2}>
        <Grid item sm={12} md={12}>
          <Typography>Leveransalternativ</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
            <InputLabel>Faktura</InputLabel>
            <Select
              value={
                client.DeliveryOptionInvoice ? client.DeliveryOptionInvoice : 0
              }
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) =>
                handleInputChange("DeliveryOptionInvoice", e.target.value)
              }
              name="DeliveryOptionInvoice"
              label="Faktura"
              size="small"
            >
              {DeliveryOptions.map((item) => (
                <MenuItem key={item.Value} value={item.Value}>
                  {item.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
            <InputLabel>Påminnelser</InputLabel>
            <Select
              value={
                client.DeliveryOptionReminder
                  ? client.DeliveryOptionReminder
                  : 2
              }
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) =>
                handleInputChange("DeliveryOptionReminder", e.target.value)
              }
              name="DeliveryOptionReminder"
              label="Påminnelser"
              size="small"
            >
              {DeliveryOptions.map((item) => (
                <MenuItem key={item.Value} value={item.Value}>
                  {item.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
}
